import clsx from 'clsx';
import { HTMLAttributes } from 'react';

import styles from './ChartTooltip.module.scss';

export const ChartTooltipItem = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div className={clsx(styles.item, className)} {...props} />
);
